import { Eleicao } from "./eleicao.model";

export class CargoNew {
    constructor(
        public id?: number,
        public nome?: string,
        public informacao?: string,   
        public qtdElegiveis?: number,
        public eleicao?: Eleicao,
        public labelCargo?: string,
        public plano?: string  
    ) { }

   
}